// src/components/Header.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLanguageFromPathname, withLanguagePrefix } from '../utils/languageRoutes';
import 'bootstrap/dist/css/bootstrap.min.css'; // Импортируем Bootstrap
import '../css/Header.css';

function Header() {
  const { t } = useTranslation();
  const location = useLocation();
  const language = getLanguageFromPathname(location.pathname);

  return (
    <header className="header-container">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col text-center">
            <h1 className="header-title">
              <Link to={withLanguagePrefix('/', language)} className="header-title-link">{t('header_title')}</Link>
            </h1>
            <p className="header-subtitle">{t('header_subtitle')}</p>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
